// src/components/NotFound.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { FiHome, FiArrowLeft } from "react-icons/fi";
import Navbar from "./Navbar";
import Footer from "./Footer";
import TopInfoBar from "./TopInfoBar";

export default function NotFound() {
  const navigate = useNavigate();
  const blue = "#3366CC";
  const text = "#0F172A";
  const isLoggedIn =
    typeof window !== "undefined" && sessionStorage.getItem("isLoggedIn") === "true";

  const container = {
    width: "100%",
    background: "#fff",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    fontFamily:
      "Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial",
  };

  return (
    <div style={container}>
      <div style={{ position: "sticky", top: 0, zIndex: 1000, background: "#fff" }}>
        <TopInfoBar blue={blue} />
        <Navbar text={text} isLoggedIn={isLoggedIn} />
      </div>

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "80px 24px",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: 120,
            fontWeight: 800,
            color: "#1F376C",
            margin: 0,
            lineHeight: 1,
          }}
        >
          404
        </h1>
        <h2
          style={{
            fontSize: 32,
            fontWeight: 700,
            color: "#334155",
            marginTop: 16,
            marginBottom: 12,
          }}
        >
          Page Not Found
        </h2>
        <p
          style={{
            fontSize: 16,
            color: "#64748B",
            maxWidth: 500,
            marginBottom: 32,
            lineHeight: 1.6,
          }}
        >
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", justifyContent: "center" }}>
          <button
            onClick={() => navigate("/")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "12px 24px",
              fontSize: 16,
              fontWeight: 600,
              color: "#fff",
              background: blue,
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              transition: "background 0.2s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.background = "#2555B8")}
            onMouseOut={(e) => (e.currentTarget.style.background = blue)}
          >
            <FiHome size={18} />
            Go Home
          </button>
          <button
            onClick={() => navigate(-1)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "12px 24px",
              fontSize: 16,
              fontWeight: 600,
              color: "#334155",
              background: "#F1F5F9",
              border: "1px solid #E2E8F0",
              borderRadius: 8,
              cursor: "pointer",
              transition: "background 0.2s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.background = "#E2E8F0")}
            onMouseOut={(e) => (e.currentTarget.style.background = "#F1F5F9")}
          >
            <FiArrowLeft size={18} />
            Go Back
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
}
